import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getPricingByCurrency} from 'utils/getPricingByCurrency'

type Props = {
  availability?: Ventrata.Availability
  currency: Basic.Currency
}

export const TotalPerBooking = ({availability, currency}: Props) => {
  const total = getPricingByCurrency(availability?.pricing, currency)?.retail

  return total !== null ? (
    <div className="py-4 flex justify-between font-bold">
      <div>Total</div>
      <div>{formatMoney(total, currency)}</div>
    </div>
  ) : null
}
